import { Quote } from "lucide-react";
import { TESTIMONIALS } from "../mock/mock";
import useReveal from "../hooks/useReveal";

export default function Testimonials() {
  const [ref, inView] = useReveal();

  return (
    <section id="temoignages" className="bg-[#5c2751] py-16 md:py-24">
      <div className="max-w-5xl mx-auto px-5 md:px-8">
        <h2 className="text-center font-heading text-3xl md:text-4xl font-extrabold text-white">
          Ils ont lu le récit
        </h2>
        <div
          ref={ref}
          className={`mt-12 grid sm:grid-cols-2 gap-6 ${inView ? "reveal in-view" : "reveal"}`}
        >
          {TESTIMONIALS.map((t) => (
            <figure
              key={t.name}
              className="flex h-full flex-col rounded-2xl bg-white/[0.07] border border-white/10 p-6"
            >
              <Quote className="h-7 w-7 text-white/50" />
              <blockquote className="mt-3 flex-1 text-[15px] italic leading-relaxed text-white/90">
                {t.text}
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-white text-sm font-bold text-[#5c2751]">
                  {t.name.charAt(0)}
                </span>
                <span className="text-sm font-semibold text-white">{t.name}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
